import type { LinkState } from "@gsignatures/core";
import { HttpSignerApi } from "./client";
import { FAKE_STEPS, FakeSignerApi, type FakeStep } from "./fake";
import type { SignerApi } from "./types";

const STATES: readonly LinkState[] = ["ready", "expired", "paused", "completed", "voided", "declined", "paper"];

/** The in-browser fake runs with `?demo=1`, with VITE_FAKE=1, and under test. */
export function isFakeMode(search: string): boolean {
  const q = new URLSearchParams(search);
  return q.get("demo") === "1" || import.meta.env.VITE_FAKE === "1" || import.meta.env.MODE === "test";
}

export function createApi(token: string, search: string): SignerApi {
  if (!isFakeMode(search)) return new HttpSignerApi(token);
  const q = new URLSearchParams(search);
  const state = q.get("state") as LinkState | null;
  const step = q.get("step") as FakeStep | null;
  return new FakeSignerApi({
    ...(state && STATES.includes(state) ? { state } : {}),
    ...(step && FAKE_STEPS.includes(step) ? { step } : {}),
    latencyMs: import.meta.env.MODE === "test" ? 0 : 280,
  });
}

export type { SignerApi } from "./types";
